import RefData from 'ref-data';
import { Experience } from 'common-entities';
import { NGXAjax } from '../../common/Services/AjaxService';
import { ApiUtils } from '../../common/api';
import PublishingDestinationsCollection from './publishing-destinations-collection';
import PublishingDestinationsModel from './publishing-destinations-model';

function publishPublishingDestination(displayContainerId) {
  return NGXAjax.post('/api/xp/container/publishNow.json', {
    id:       displayContainerId,
    validate: true,
  })
    .then(ApiUtils.validate, ApiUtils.validate)
    .then(ApiUtils.extract1)
    .then(PublishingDestinationsModel.deserialize)
    .catch((error) => ({ error }));
}

function expirePublishingDestination(displayContainerId) {
  return NGXAjax.post('/api/xp/container/expireNow.json', {
    id:       displayContainerId,
    validate: true,
  })
    .then(ApiUtils.validate, ApiUtils.validate)
    .then(ApiUtils.extract1)
    .then(PublishingDestinationsModel.deserialize)
    .catch((error) => ({ error }));
}

function fetchPublishingDestinations(experienceId) {
  return NGXAjax.get('/api/xp/campaign/publishingDestinations.json', {
    validate: true,
    id:       experienceId,
  })
    .then(ApiUtils.validate, ApiUtils.validate)
    .then(ApiUtils.extract)
    .then(PublishingDestinationsCollection.deserialize)
    .catch((error) => ({ error }));
}

function createPublishingDestination(experienceId, params = {}) {
  const {
    appName,
    channelId,
    displayUnitId,
    containerType,
    width,
    height,
    ratio,
    privacyMgmt,
    displayConfig,
    privacyConfig,
    containerId,
    isStaging,
  } = params;
  return NGXAjax.post('/api/xp/campaign/addDestination.json', {
    id:    experienceId,
    appName,
    channelId,
    duId:  displayUnitId,
    containerType,
    width,
    height,
    ratio,
    privacyMgmt,
    displayConfig,
    privacyConfig,
    containerId,
    force: isStaging, // staging destinations are not going through the checks
  })
    .then(ApiUtils.validate, ApiUtils.validate)
    .then(ApiUtils.extract1)
    .then(PublishingDestinationsModel.deserialize)
    .catch((error) => ({ error }));
}

function removePublishingDestination(publishingDestinationData, experienceId) {
  const hydratedPublishingDestinationData = JSON.parse(publishingDestinationData);
  return NGXAjax.post(`/api/xp/campaign/unassigndc/${experienceId}.json`, {
    DCId: hydratedPublishingDestinationData.displayContainerId,
  })
    .then(ApiUtils.extract1)
    .then(Experience.Model.deserialize)
    .catch((error) => ({ error }));
}

function checkCampaignValidity(experienceId) {
  return NGXAjax.get('/api/campaign/validityCheckCampaign.json', {
    id:           experienceId,
    onlyCritical: true,
    publishMode:  RefData.Enum.MODE.PUBLISH.PRODUCTION,
  })
    .then(ApiUtils.validate, ApiUtils.validate)
    .then(ApiUtils.extract1)
    .catch((error) => ({ error }));
}

function statusAction(displayContainerId, statusAction) {
  return NGXAjax.get(`/api/container/resolveAction/${displayContainerId}.json`, {
    task:     statusAction,
    validate: true,
  })
    .then(ApiUtils.validate, ApiUtils.validate)
    .then(ApiUtils.extract1)
    .catch((error) => ({ error }));
}

export default {
  expirePublishingDestination,
  publishPublishingDestination,
  fetchPublishingDestinations,
  createPublishingDestination,
  removePublishingDestination,
  checkCampaignValidity,
  statusAction,
};
